import React from 'react';
import { Box, Dialog } from '@mui/material';

// Common image styles used across admin components
export const commonImageStyles = {
  width: 96,
  height: 96,
  objectFit: 'contain',
  borderRadius: 8,
  border: '1px solid #ddd',
  cursor: 'pointer',
  background: '#fafafa',
};

// Reusable image preview dialog component
export const ImagePreviewDialog = ({ open, onClose, imageUrl }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
    >
      <Box sx={{ p: 2, minWidth: 300, minHeight: 200, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        {imageUrl && (
          <img
            src={imageUrl}
            alt="Preview"
            style={{
              maxWidth: "90vw",
              maxHeight: "80vh",
              display: "block",
              margin: "auto",
            }}
            onError={(e) => {
              e.target.onerror = null;
              e.target.style.display = 'none';
              const errorText = e.target.parentElement.querySelector('.error-text') || document.createElement('p');
              errorText.textContent = 'Image not found';
              errorText.className = 'error-text';
              errorText.style.color = '#f44336';
              errorText.style.textAlign = 'center';
              if (!e.target.parentElement.contains(errorText)) {
                e.target.parentElement.appendChild(errorText);
              }
            }}
          />
        )}
      </Box>
    </Dialog>
  );
};

// Reusable clickable image component
export const ClickableImage = ({ src, alt, onClick }) => {
  return (
    <img
      src={src}
      alt={alt}
      style={commonImageStyles}
      onClick={onClick}
      onError={(e) => {
        e.target.onerror = null;
        e.target.src = '';
      }}
    />
  );
};
